import React from 'react';
import { Car, Gauge, Fuel, Users } from 'lucide-react';

/**
 * Компонент секции параметров транспортного средства
 */
const VehicleParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  vehicleTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Car className="w-5 h-5 mr-2 text-blue-500" />
        Параметры транспорта
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип транспорта */}
        <div>
          <label htmlFor="vehicleType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип транспорта
          </label>
          <select
            id="vehicleType"
            name="vehicleType"
            value={formData.vehicleType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {vehicleTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        {/* Средняя скорость */}
        <div>
          <label htmlFor="averageSpeed" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Gauge className="w-4 h-4 mr-2 text-blue-500" />
            Средняя скорость (км/ч)
          </label>
          <input
            type="text"
            id="averageSpeed"
            name="averageSpeed"
            value={formData.averageSpeed}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.averageSpeed ? 'input-error' : ''}`}
            placeholder="Средняя скорость движения"
          />
          {errors.averageSpeed && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.averageSpeed}
            </p>
          )}
        </div>

        {/* Количество пассажиров */}
        <div>
          <label htmlFor="numPassengers" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-2 text-blue-500" />
            Количество пассажиров
          </label>
          <input
            type="number"
            id="numPassengers"
            name="numPassengers"
            value={formData.numPassengers}
            onChange={handleInputChange}
            min="1"
            max="50"
            className={`form-input w-full ${errors.numPassengers ? 'input-error' : ''}`}
            placeholder="Количество людей"
          />
          {errors.numPassengers && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.numPassengers}
            </p>
          )}
        </div>

        {/* Расход топлива */}
        <div>
          <label htmlFor="fuelConsumption" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Fuel className="w-4 h-4 mr-2 text-blue-500" />
            Расход топлива (л/100км)
          </label>
          <input
            type="text"
            id="fuelConsumption"
            name="fuelConsumption"
            value={formData.fuelConsumption}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.fuelConsumption ? 'input-error' : ''}`}
            placeholder="Средний расход"
          />
          {errors.fuelConsumption && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.fuelConsumption}
            </p>
          )}
        </div>

        {/* Цена топлива */}
        <div>
          <label htmlFor="fuelPrice" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Цена топлива (руб/л)
          </label>
          <input
            type="text"
            id="fuelPrice"
            name="fuelPrice"
            value={formData.fuelPrice}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.fuelPrice ? 'input-error' : ''}`}
            placeholder="Стоимость топлива"
          />
          {errors.fuelPrice && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.fuelPrice}
            </p>
          )}
        </div>

        {/* Индикатор средней скорости по типу транспорта */}
        <div className="col-span-full mt-2">
          <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">
            Средняя скорость по типу транспорта:
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            {vehicleTypes.map((type) => (
              <span 
                key={type.id}
                className={`px-2 py-1 rounded-full text-xs ${
                  formData.vehicleType === type.id
                    ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300 border border-blue-300 dark:border-blue-700'
                    : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400'
                }`}
              >
                {type.name}: {type.defaultSpeed} км/ч
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleParametersSection;